<div class="panel panel-default overviewPanel"
  *ngIf="dataLoaded && bookingSectionComplete && bookingType !== 'amend'">


  <div *ngIf="bookingType !== 'amend'" class="hidden-lg hidden-md progressbar progressbar--status-{{ currentPanel }}">
  </div>

  <ng-container *ngIf="isD2dService; then d2d; else notD2d"></ng-container>

  <ng-template #d2d>

    <div class="booking-summary__header panel-body" (click)="toggleOverviewDrawer()">
      <div>
        <div class="flex-always margin-top-0 margin-bottom-0 flex-1">
          <h5 class="dropdown-heading flex-always flex--align-center text-extra-bold margin-top-0 margin-bottom-0">
            <span class="mobile">
              <i class="icon">edit</i>
            </span>
            {{ appCopy.panelHeader['title'+selectedLanguage] }}
          </h5>
          <span class="mobile flex-always ml-auto px-md">
            <span class="icon-pill px-sm">
              <span class="icon-bag"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>
            </span>
            <span class="icon-pill px-sm">
              <span class="icon-plane-up-outline"></span>
            </span>
            <span class="icon-pill px-sm">
              <span class="icon-location"></span>
            </span>
          </span>

          <i class="icon hidden-md hidden-lg icon-dropdown">chevron_down</i>
        </div>
        <b *ngIf="priceLoaded && showPrice && price.responseStatus === 1 && inboundBooking.price.totalPrice && outboundBooking.price.totalPrice" class="mobile_price-section">
          {{ appCopy.panelHeader['total'+selectedLanguage] }} &nbsp;&nbsp;&nbsp;
          {{inboundBooking.price.totalPrice.currencySymbol}}{{inboundBooking.price.totalPrice.currencySymbol==="CHF"
              ? ' ' :
              ''}}{{ getD2dTotalPrice() }}
        </b>
      </div>
    </div>

    <div class="booking-summary__content">

      <!-- OUTBOUND -->
      <div *ngIf="(isD2dService && !isObjectEmpty(d2dBookingState.outboundBooking)) || bookingABC"
        class="panel-body booking-type booking-type-dropdown" [ngClass]="{
        'step--active': showDepartureDetails === true
      }" (click)="toggleDetails('abc')">
        <div class="booking-type-heading">
          <span class="icon-wrapper">
            <i class="icon-departure"></i>
          </span>

          <label class="booking-type-label text-bold flex-always flex--space-between m-0" for="BagCount">
            <div>
              <p>{{appCopy.panelHeaderOutBound['departureDropdownLabel'+selectedLanguage]}}</p>
              <button class="btn-danger-text" (click)="onRemoveService($event, 'abc')">{{appCopy.panelHeaderInBound['removeTitle'+selectedLanguage]}}</button>
            </div>
            <span *ngIf="!priceLoading && priceLoaded && outboundBooking.price.totalPrice && (showPrice || outboundDiscountedPrice > 0)">
              {{outboundBooking.price.totalPrice.currencySymbol}}{{outboundBooking.price.totalPrice.currencySymbol==="CHF"
              ? ' ' :
              ''}}{{outboundDiscountedPrice}}</span>
            <div *ngIf="priceLoading" class="loader-container price-loader">
              <div class="loader">
                <svg class="circular" viewBox="10 10 20 20">
                  <circle class="path" cx="20" cy="20" r="8" />
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>

      <!-- OUTBOUND -->
      <div *ngIf="showDepartureDetails && !isObjectEmpty(d2dBookingState.outboundBooking)" [@Dropdown]>
        <div class="panel-body">
          <div class='booking-summary__bagsDropdown'>
            <!-- header -->
            <div class="flex-always flex--space-between flex--align-end dropdownHeader"
              (click)="toggleBagsDropdown('outbound')">
              <div class='flex-always flex__item--grow '>
                <i class="icon">luggage</i>
                <p class='dropdown-title margin-left-24'>{{ appCopy.panelHeaderOutBound['bagLable'+selectedLanguage] }}
                </p>
              </div>
              <i class="icon">{{toggleDepartureDropdown ? 'chevron_up' : 'chevron_down'}}</i>
            </div>
            <!-- body -->
            <div *ngIf="toggleDepartureDropdown" [@Dropdown] class="dropdownBody padding-left-24">
              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['bagInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span class="text-extra-bold">{{ appCopy.panelHeaderOutBound['bagsSelectText'+selectedLanguage]
                    }}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(outboundBooking.bagItems.bags-1, 'bags', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="outboundBooking.bagItems.bags === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{outboundBooking.bagItems.bags}}</strong>
                  <button (click)="updateBagItems(outboundBooking.bagItems.bags+1, 'bags', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="outboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['childItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['childItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(outboundBooking.bagItems.childEquipment-1, 'childEquipment', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="outboundBooking.bagItems.childEquipment === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{outboundBooking.bagItems.childEquipment}}</strong>
                  <button (click)="updateBagItems(outboundBooking.bagItems.childEquipment+1, 'childEquipment', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="outboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['supportItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['supportItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(outboundBooking.bagItems.oversizeItem-1, 'oversizeItem', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="outboundBooking.bagItems.oversizeItem === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{outboundBooking.bagItems.oversizeItem}}</strong>
                  <button (click)="updateBagItems(outboundBooking.bagItems.oversizeItem+1, 'oversizeItem', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="outboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>
              <p class="info-block">{{appCopy.panelHeaderOutBound['minPricePerBag'+selectedLanguage].replace('%s', outboundAdditionBagPrice)}}</p>
              <p *ngIf="virtualBags === 0" class="help-block text-danger">{{appCopy.panelHeaderOutBound['leastItemMessage'+selectedLanguage]}}</p>
              <p *ngIf="virtualBags > 25" class="help-block text-danger">{{appCopy.panelHeaderOutBound['maxBagItemError'+selectedLanguage]}}</p>
            </div>
          </div>
        </div>

        <div class="booking-steps">
          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 1,
            'step--inactive': currentPanel < 1,
            'step--complete': currentPanel > 1
          }">
            <div class="flex flex-always flex--align-start">
              <img style="margin-right: 28px;" class="airline-logo-full-small" [src]="'./images/airline-logo-small/' + airlineName + '.svg'" [alt]="airlineName + ' logo'" />

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['bagInjectText'+selectedLanguage]}}</p>
                <div class="step__details">
                  <p>
                    <strong class="is-active">{{ appCopy.panelHeaderOutBound['activeFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['inactiveFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ outboundBooking.flightData.flightResponse.flightStatusDetails[0].airlineName }}
                      {{outboundBooking.flightData.flightResponse.flightInfo.requestFlightNumber }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ appCopy.panelHeaderOutBound['to'+selectedLanguage] }}
                    {{
                    appAirportCopy[outboundBooking.flightData.flightResponse.flightStatusDetails[outboundBooking.flightData.flightResponse.flightStatusDetails.length
                    - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage]}}
                  </p>
                </div>
              </div>
              <a class="btn btn-link" href="javascript:void(0)" (click)="goToFlightResults()"><i
                  class="icon">edit</i></a>
            </div>
          </div>
          <!-- collection address -->
          <div *ngIf="!isHubdropBooking" class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2 && bookingABC,
            'step--inactive': currentPanel < 2 && bookingABC,
            'step--complete': currentPanel > 2 || (!bookingABC && outboundBooking.isCompleted)
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 2}" >
              <i class="icon-location step__icon "></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['addressText'+selectedLanguage]
                  }}</p>

                <!-- OUTBOUND - collection-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['addressActiveText'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['addressInactiveText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.name ?
                      outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.name :
                      outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.addressLine1 + ' ' +
                      outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].collectionLocation.name">
                  {{ currentBooking.bookingJourney[0].collectionLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.addressPostCode }}, {{
                    outboundBooking.currentBooking.bookingJourney[0].collectionLocation?.addressTown }}
                  </p>
                </div>


              </div>
              <!-- <a *ngIf="((flightDirection === 1 && bookingSectionComplete.collectionLocationDetails)) && !isAmend" -->
              <a class="btn btn-link"
                href="javascript:void(0)" (click)="goToPanel('collection-location')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>
          <!-- drop off address -->
          <div *ngIf="isHubdropBooking" class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2 && bookingABC,
            'step--inactive': currentPanel < 2 && bookingABC,
            'step--complete': currentPanel > 2 || (!bookingABC && outboundBooking.isCompleted)
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 3}" >
              <i class="icon-location step__icon "></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['dropOff'+selectedLanguage]}}</p>

                <!-- OUTBOUND - collection-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['addressActiveText'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['dropOff'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ selectPostOffice.name ?
                      selectPostOffice.name :
                      selectPostOffice.addressLine1 + ' ' +
                      selectPostOffice.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].collectionLocation.name">
                  {{ currentBooking.bookingJourney[0].collectionLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ selectPostOffice.addressPostCode }}, {{
                    selectPostOffice.addressTown }}
                  </p>
                </div>


              </div>
              <!-- <a *ngIf="((flightDirection === 1 && bookingSectionComplete.collectionLocationDetails)) && !isAmend" -->
              <a class="btn btn-link"
                href="javascript:void(0)" (click)="goToPanel('collection-post-office')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2 && bookingABC,
            'step--inactive': currentPanel < 2 && bookingABC,
            'step--complete': currentPanel > 2 || (!bookingABC && outboundBooking.isCompleted)
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 3}" >
              <i class="icon-time step__icon ">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['bagJobDateLabel'+selectedLanguage] }}
                </p>

                <!-- OUTBOUND - timeslot-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['timesloteActive'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['bagJobDateLabel'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ outboundBooking.timeslot.date | date:'E, d MMM yyyy' :'' : languageCode }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ outboundBooking.timeslot.start }} - {{ outboundBooking.timeslot.end }}
                  </p>
                </div>


              </div>
              <!-- <a *ngIf="((flightDirection === 1 && bookingSectionComplete.collectionDateTimeDetails) || (!bookingABC && outboundBooking.isCompleted)) && !isAmend" -->
              <a *ngIf="!isHubdropBooking && currentPanel === 4" class="btn btn-link" href="javascript:void(0)"
                (click)="goToPanel('collection-time')">
                <i class="icon">edit</i>
              </a>
              <a *ngIf="isHubdropBooking && currentPanel === 4" class="btn btn-link" href="javascript:void(0)"
                (click)="goToPanel('collection-post-office')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

        </div>

      </div>

      <!-- INBOUND -->
      <div *ngIf="(isD2dService && !isObjectEmpty(d2dBookingState.inboundBooking)) || !bookingABC"
        class="panel-body booking-type booking-type-dropdown" [ngClass]="{
        'step--active': showArrivalDetails === true
      }" (click)="toggleDetails('ccd')">
        <div class="booking-type-heading">
          <span class="icon-wrapper">
            <i class="icon-departure rotate-45"></i>
          </span>

          <label class="booking-type-label text-bold flex-always flex--space-between m-0" for="BagCount">
            <div>
              <p>{{appCopy.panelHeaderInBound['arrivalDropdownLabel'+selectedLanguage]}}</p>
              <button class="btn-danger-text" (click)="onRemoveService($event, 'ccd')">{{appCopy.panelHeaderInBound['removeTitle'+selectedLanguage]}}</button>
            </div>
            <span *ngIf="!priceLoading && (showPrice || inboundDiscountedPrice > 0) ">
              {{inboundBooking.price?.totalPrice?.currencySymbol}}{{inboundBooking.price?.totalPrice?.currencySymbol==="CHF"
              ? ' ' :
              ''}}{{ inboundDiscountedPrice }}</span>
            <div *ngIf="priceLoading" class="loader-container price-loader">
              <div class="loader">
                <svg class="circular" viewBox="10 10 20 20">
                  <circle class="path" cx="20" cy="20" r="8" />
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>

      <!-- INBOUND -->
      <div *ngIf="showArrivalDetails && !isObjectEmpty(d2dBookingState.inboundBooking)" [@Dropdown]>
        <div class="panel-body">
          <!-- <div class="form-group with-icon with-select">
          <i class="icon">luggage</i>
          <select #BagCount class="form-control" id="BagCount" name="BagCount" [(ngModel)]="virtualBags"
            (ngModelChange)="updateBags($event)" appCheckEmpty>
            <option value="" disabled></option>
            <option *ngFor="let bagNb of bagsArr" [value]="bagNb">{{ bagNb }} {{ bagNb === 1 ?
              appCopy.panelHeader['bagSelectText'+selectedLanguage] :
              appCopy.panelHeader['bagsSelectText'+selectedLanguage] }}</option>
          </select>
          <label class="control-label" for="BagCount">{{ appCopy.panelHeader['bagLable'+selectedLanguage] }}</label>
        </div> -->

          <div class='booking-summary__bagsDropdown'>
            <!-- header -->
            <div class="flex-always flex--space-between flex--align-end dropdownHeader"
              (click)="toggleBagsDropdown('inbound')">
              <div class='flex-always flex__item--grow '>
                <i class="icon">luggage</i>
                <p class='dropdown-title margin-left-24'>{{ appCopy.panelHeaderInBound['bagLable'+selectedLanguage] }}
                </p>
              </div>
              <i class="icon">{{toggleArrivalDropdown ? 'chevron_up' : 'chevron_down'}}</i>
            </div>
            <!-- body -->
            <div *ngIf="toggleArrivalDropdown" [@Dropdown] class="dropdownBody padding-left-24">
              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['bagInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span class="text-extra-bold">{{ appCopy.panelHeaderOutBound['bagsSelectText'+selectedLanguage]
                    }}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(inboundBooking.bagItems.bags-1, 'bags', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="inboundBooking.bagItems.bags === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{inboundBooking.bagItems.bags}}</strong>
                  <button (click)="updateBagItems(inboundBooking.bagItems.bags+1, 'bags', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="inboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['childItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['childItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(inboundBooking.bagItems.childEquipment-1, 'childEquipment', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="inboundBooking.bagItems.childEquipment === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{inboundBooking.bagItems.childEquipment}}</strong>
                  <button (click)="updateBagItems(inboundBooking.bagItems.childEquipment+1, 'childEquipment', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="inboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['supportItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['supportItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(inboundBooking.bagItems.oversizeItem-1, 'oversizeItem', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8'
                    [disabled]="inboundBooking.bagItems.oversizeItem === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{inboundBooking.bagItems.oversizeItem}}</strong>
                  <button (click)="updateBagItems(inboundBooking.bagItems.oversizeItem+1, 'oversizeItem', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8'
                    [disabled]="inboundBooking.virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>
              <p class="info-block">{{appCopy.panelHeaderOutBound['minPricePerBag'+selectedLanguage].replace('%s', inboundAdditionBagPrice)}}</p>
              <p *ngIf="virtualBags === 0" class="help-block text-danger">{{appCopy.panelHeaderOutBound['leastItemMessage'+selectedLanguage]}}</p>
              <p *ngIf="virtualBags > 25" class="help-block text-danger">{{appCopy.panelHeaderOutBound['maxBagItemError'+selectedLanguage]}}</p>
            </div>
          </div>
        </div>

        <div class="booking-steps">
          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 1,
            'step--inactive': currentPanel < 1,
            'step--complete': currentPanel > 1
          }">
            <div class="flex flex-always flex--align-start">
              <img style="margin-right: 28px;" class="airline-logo-full-small" [src]="'./images/airline-logo-small/' + airlineName + '.svg'" [alt]="airlineName + ' logo'" />

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                    appCopy.panelHeaderInBound['bagInjectText'+selectedLanguage]}}</p>
                <div class="step__details">
                  <p>
                    <strong class="is-active">{{ appCopy.panelHeaderInBound['activeFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['inactiveFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ inboundBooking.flightData.flightResponse.flightStatusDetails[inboundBooking.flightData.flightResponse.flightStatusDetails.length - 1].airlineName }}
                      {{inboundBooking.flightData.flightResponse.flightInfo.requestFlightNumber }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ appCopy.panelHeaderInBound['to'+selectedLanguage] }}
                    {{
                    appAirportCopy[inboundBooking.flightData.flightResponse.flightStatusDetails[inboundBooking.flightData.flightResponse.flightStatusDetails.length
                    - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage]}}
                  </p>
                </div>
              </div>
              <a class="btn btn-link" href="javascript:void(0)" (click)="goToFlightResults()"><i
                  class="icon">edit</i></a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2 && !bookingABC,
            'step--inactive': currentPanel < 2 && !bookingABC,
            'step--complete': currentPanel > 2 || (bookingABC && inboundBooking.isCompleted)
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 2}" >
              <i class="icon-location step__icon"></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{ appCopy.panelHeaderInBound['addressText'+selectedLanguage]
                  }}</p>

                <!-- INBOUND - delivery-->
                <div class="step__details">
                  <p>
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['addressText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.name ?
                      inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.name :
                      inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.addressLine1 + ' ' +
                      inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].deliveryLocation.name">
                  {{ currentBooking.bookingJourney[0].deliveryLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.addressPostCode }}, {{
                    inboundBooking.currentBooking.bookingJourney[0].deliveryLocation?.addressTown }}
                  </p>
                </div>
              </div>
              <a class="btn btn-link"
                href="javascript:void(0)" (click)="goToPanel('delivery-location')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 3 && !bookingABC,
            'step--inactive': currentPanel < 3 && !bookingABC,
            'step--complete': currentPanel > 3 || (bookingABC && inboundBooking.isCompleted)
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 3}" >
              <i class="icon-time step__icon ">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderInBound['bagJobDateLabel'+selectedLanguage] }}
                </p>

                <!-- INBOUND - timeslot-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderInBound['timesloteActive'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['bagJobDateLabel'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ inboundBooking.timeslot.date | date:'E, d MMM yyyy' :'' : languageCode }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ inboundBooking.timeslot.start }} - {{ inboundBooking.timeslot.end }}
                  </p>
                </div>
              </div>
              <a class="btn btn-link"
                href="javascript:void(0)" (click)="goToPanel('delivery-time')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

        </div>

      </div>

      <div class="panel-body booking-type no-before" [ngClass]="{
      'step--highlight': priceLoaded && showPrice && inboundBooking.price.totalPrice
      }">
        <div class="booking-type-heading ">
          <span class="icon-wrapper">
            <i class="icon-payment"></i>
          </span>

          <label class="booking-type-label text-bold" for="BagCount">
            <p class="step__title text-bold fadeIn">{{ appCopy.panelHeader['paymentReviewText'+selectedLanguage] }}
            </p>
            <!-- <div class="step__details">
              <p>
                <strong class="is-active">{{ appCopy.panelHeader['paymentActiveText'+selectedLanguage] }}</strong>
                <strong class="is-inactive">{{ appCopy.panelHeader['paymentReviewText'+selectedLanguage] }}</strong>
                <strong class="is-complete"></strong>
              </p>
            </div> -->
          </label>
        </div>
      </div>


      <div class="reveal reveal__price-view reveal--small"
        *ngIf="priceLoaded && showPrice && price.responseStatus === 1 && inboundBooking.price.totalPrice && outboundBooking.price.totalPrice">

        <div class="reveal__always_show panel-body">

          <div class="desktopViewSidePanel" *ngIf="screenSize > 1024">
            <app-promo [price]="price" [user]="user" [togglePromo]="togglePromo" [appCopy]="appCopy"
              [selectedLanguage]='selectedLanguage'>
            </app-promo>
            <!--- Begin Mention Me referee placeholder div -->
            <!-- <div id="mmWrapper" class="margin-top-12 mmWrapper--link" (click)="togglePromo = true"></div> -->
            <!--- End Mention Me referee placeholder div -->
          </div>

          <div class="margin-top-16">

            <div class="flex-always flex--space-between">
              <div>
                <p>{{ appCopy.panelHeader['total'+selectedLanguage] }}</p>
              </div>
              <p class="total-price">
                {{inboundBooking.price.totalPrice.currencySymbol}}{{inboundBooking.price.totalPrice.currencySymbol==="CHF"
                ? ' ' :
                ''}}{{ getD2dTotalPrice() }}</p>
            </div>
          </div>
          <a class="price-breakdown-button" (click)="openPriceBreakDown()">{{ appCopy.panelHeader['priceBreakdownTitle'+selectedLanguage] }}</a>
        </div>
      </div>

      <!-- <button class="btn hidden-sm hidden-xs chat-btn" (click)="handleChatClick()">
      <div *ngIf="!chatIsLoading"> <i class="far fa-comment"></i>&nbsp;Chat</div>
      <div class="loader-container-btn" *ngIf="chatIsLoading">
        <div class="loader loader--gray">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
    </button> -->
    </div>
  </ng-template>

  <ng-template #notD2d>
    <div class="booking-summary__header panel-body" (click)="toggleOverviewDrawer()">
      <div>
        <div class="flex-always margin-top-0 margin-bottom-0 flex-1">
          <h5 class="dropdown-heading flex-always flex--align-center text-extra-bold margin-top-0 margin-bottom-0">
            <span class="mobile">
              <i class="icon">edit</i>
            </span>
            {{ appCopy.panelHeader['title'+selectedLanguage] }}
          </h5>
          <span class="mobile flex-always px-md ml-auto">
            <span class="icon-pill px-sm">
              <span class="icon-bag"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span></span>
            </span>
            <span class="icon-pill px-sm">
              <span class="icon-plane-up-outline"></span>
            </span>
            <span class="icon-pill px-sm">
              <span class="icon-location"></span>
            </span>
          </span>

          <i class="icon hidden-md hidden-lg icon-dropdown">chevron_down</i>
        </div>
        <b *ngIf="priceLoaded && showPrice && price.totalPrice" class="mobile_price-section">
          {{ appCopy.panelHeader['total'+selectedLanguage] }} &nbsp;&nbsp;&nbsp;
          {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF"
              ? ' ' :
              ''}}{{ price.totalPrice.majorAmount}}
        </b>
      </div>
    </div>
    <div class="booking-summary__content">

      <!-- OUTBOUND -->
      <div *ngIf="bookingABC" class="panel-body booking-type booking-type-dropdown" [ngClass]="{
        'step--active': showDepartureDetails === true
      }" (click)="toggleDetails('abc')">
        <div class="booking-type-heading">
          <span class="icon-wrapper">
            <i class="icon-departure"></i>
          </span>

          <label class="booking-type-label text-bold flex-always flex--space-between" for="BagCount">{{
            appCopy.panelHeaderOutBound['departureDropdownLabel'+selectedLanguage] }}
            <span *ngIf="!priceLoading && priceLoaded && (showPrice || price.totalPrice && currentPanel > 3)">
              {{price?.totalPrice?.currencySymbol}}{{price?.totalPrice?.currencySymbol==="CHF" ? ' ' :
              ''}}{{ price?.totalPrice?.majorAmount }}</span>
            <div *ngIf="priceLoading" class="loader-container price-loader">
              <div class="loader">
                <svg class="circular" viewBox="10 10 20 20">
                  <circle class="path" cx="20" cy="20" r="8" />
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>

      <!-- OUTBOUND -->
      <div *ngIf="showDepartureDetails" [@Dropdown]>
        <div class="panel-body">
          <!-- <div class="form-group with-icon with-select">
          <i class="icon">luggage</i>
          <select #BagCount class="form-control" id="BagCount" name="BagCount" [(ngModel)]="virtualBags"
            (ngModelChange)="updateBags($event)" appCheckEmpty>
            <option value="" disabled></option>
            <option *ngFor="let bagNb of bagsArr" [value]="bagNb">{{ bagNb }} {{ bagNb === 1 ?
              appCopy.panelHeader['bagSelectText'+selectedLanguage] :
              appCopy.panelHeader['bagsSelectText'+selectedLanguage] }}</option>
          </select>
          <label class="control-label" for="BagCount">{{ appCopy.panelHeader['bagLable'+selectedLanguage] }}</label>
        </div> -->
          <div class='booking-summary__bagsDropdown'>
            <!-- header -->
            <div class="flex-always flex--space-between flex--align-end dropdownHeader" (click)="toggleBagsDropdown()">
              <div class='flex-always flex__item--grow '>
                <i class="icon">luggage</i>
                <p class='dropdown-title margin-left-24'>{{ appCopy.panelHeaderOutBound['bagLable'+selectedLanguage] }}
                </p>
              </div>
              <i class="icon">{{toggleDropdown ? 'chevron_up' : 'chevron_down'}}</i>
            </div>
            <!-- body -->
            <div *ngIf="toggleDropdown" [@Dropdown] class="dropdownBody padding-left-24">
              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['bagInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span class="text-extra-bold">{{ appCopy.panelHeaderOutBound[bagItems.bags > 1 ? 'bagsSelectText' + selectedLanguage : 'bagSelectText' + selectedLanguage] }}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.bags-1, 'bags', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.bags === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.bags}}</strong>
                  <button (click)="updateBagItems(bagItems.bags+1, 'bags', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['childItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['childItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.childEquipment-1, 'childEquipment', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.childEquipment === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.childEquipment}}</strong>
                  <button (click)="updateBagItems(bagItems.childEquipment+1, 'childEquipment', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['supportItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['supportItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.oversizeItem-1, 'oversizeItem', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.oversizeItem === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.oversizeItem}}</strong>
                  <button (click)="updateBagItems(bagItems.oversizeItem+1, 'oversizeItem', 'abc')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>
              <p class="info-block">{{appCopy.panelHeaderOutBound['minPricePerBag'+selectedLanguage].replace('%s', outboundAdditionBagPrice)}}</p>
              <p *ngIf="virtualBags === 0" class="help-block text-danger">{{appCopy.panelHeaderOutBound['leastItemMessage'+selectedLanguage]}}</p>
              <p *ngIf="virtualBags > 25" class="help-block text-danger">{{appCopy.panelHeaderOutBound['maxBagItemError'+selectedLanguage]}}</p>
            </div>
          </div>
        </div>

        <div class="booking-steps">
          <!-- flight results -->
          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 1,
            'step--inactive': currentPanel < 1,
            'step--complete': currentPanel > 1
          }">
            <div class="flex flex-always flex--align-start">
              <img style="margin-right: 28px;" class="airline-logo-full-small" [src]="'./images/airline-logo-small/' + airlineName + '.svg'" [alt]="airlineName + ' logo'" />

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['bagInjectText'+selectedLanguage]}}</p>
                <div class="step__details">
                  <p>
                    <strong class="is-active">{{ appCopy.panelHeaderOutBound['activeFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['inactiveFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ flightData.flightResponse.flightStatusDetails[flightData.flightResponse.flightStatusDetails.length - 1].airlineName }}
                      {{flightData.flightResponse.flightInfo.requestFlightNumber }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ appCopy.panelHeaderOutBound['to'+selectedLanguage] }}
                    {{
                    appAirportCopy[flightData.flightResponse.flightStatusDetails[flightData.flightResponse.flightStatusDetails.length
                    - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage]}}
                  </p>
                </div>
              </div>
              <a class="btn btn-link" href="javascript:void(0)" (click)="goToFlightResults()"><i
                  class="icon">edit</i></a>
            </div>
          </div>
          <!-- collection location -->
          <div *ngIf="!isHubdropBooking" class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2,
            'step--inactive': currentPanel < 2,
            'step--complete': currentPanel > 2
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 2}" >
              <i class="icon-location step__icon "></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['addressText'+selectedLanguage]
                  }}</p>

                <!-- OUTBOUND - collection-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['addressActiveText'+selectedLanguage]
                      }}</strong>-->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['addressText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ currentBooking.bookingJourney[0].collectionLocation.name ?
                      currentBooking.bookingJourney[0].collectionLocation.name :
                      currentBooking.bookingJourney[0].collectionLocation.addressLine1 + ' ' +
                      currentBooking.bookingJourney[0].collectionLocation.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].collectionLocation.name">
                  {{ currentBooking.bookingJourney[0].collectionLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ currentBooking.bookingJourney[0].collectionLocation.addressPostCode }}, {{
                    currentBooking.bookingJourney[0].collectionLocation.addressTown }}
                  </p>
                </div>


              </div>
              <a *ngIf="flightDirection === 1 && bookingSectionComplete.collectionLocationDetails"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('collection-location')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

          <!-- drop off address -->
          <div *ngIf="isHubdropBooking" class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2,
            'step--inactive': currentPanel < 2,
            'step--complete': currentPanel > 2
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 2}" >
              <i class="icon-location step__icon "></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{ appCopy.panelHeaderOutBound['dropOff'+selectedLanguage]}}</p>

                <!-- OUTBOUND - collection-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['addressActiveText'+selectedLanguage]
                      }}</strong>-->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['addressText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ selectPostOffice.name ?
                      selectPostOffice.name :
                      selectPostOffice.addressLine1 + ' ' +
                      selectPostOffice.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].collectionLocation.name">
                  {{ currentBooking.bookingJourney[0].collectionLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ selectPostOffice.addressPostCode }}, {{
                    selectPostOffice.addressTown }}
                  </p>
                </div>


              </div>
              <a *ngIf="flightDirection === 1 && bookingSectionComplete.collectionLocationDetails"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('collection-post-office')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 3,
            'step--inactive': currentPanel < 3,
            'step--complete': currentPanel > 3
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 3}" >
              <i class="icon-time step__icon ">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderOutBound['bagJobDateLabel'+selectedLanguage] }}
                </p>

                <!-- OUTBOUND - timeslot-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderOutBound['timesloteActive'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderOutBound['bagJobDateLabel'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ timeslot.date | date:'E, d MMM yyyy' :'' : languageCode }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ timeslot.start }} - {{ timeslot.end }}
                  </p>
                </div>


              </div>
              <a *ngIf="!isHubdropBooking && flightDirection === 1 && bookingSectionComplete.collectionDateTimeDetails"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('collection-time')">
                <i class="icon">edit</i>
              </a>
              <a *ngIf="isHubdropBooking && flightDirection === 1 && bookingSectionComplete.collectionDateTimeDetails"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('collection-post-office')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>


        </div>

      </div>

      <!-- INBOUND -->
      <div *ngIf="!bookingABC" class="panel-body booking-type booking-type-dropdown" [ngClass]="{
        'step--active': showArrivalDetails === true
      }" (click)="toggleDetails('ccd')">
        <div class="booking-type-heading">
          <span class="icon-wrapper">
            <i class="icon-departure rotate-45"></i>
          </span>

          <label class="booking-type-label text-bold flex-always flex--space-between" for="BagCount">{{
            appCopy.panelHeaderInBound['arrivalDropdownLabel'+selectedLanguage] }}
            <span *ngIf="!priceLoading && priceLoaded && (showPrice || price.totalPrice && currentPanel > 3)">
              {{price?.totalPrice?.currencySymbol}}{{price?.totalPrice?.currencySymbol==="CHF" ? ' ' :
              ''}}{{ price?.totalPrice?.majorAmount }}</span>
            <div *ngIf="priceLoading" class="loader-container price-loader">
              <div class="loader">
                <svg class="circular" viewBox="10 10 20 20">
                  <circle class="path" cx="20" cy="20" r="8" />
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>

      <!-- INBOUND -->
      <div *ngIf="showArrivalDetails" [@Dropdown]>
        <div class="panel-body">
          <!-- <div class="form-group with-icon with-select">
          <i class="icon">luggage</i>
          <select #BagCount class="form-control" id="BagCount" name="BagCount" [(ngModel)]="virtualBags"
            (ngModelChange)="updateBags($event)" appCheckEmpty>
            <option value="" disabled></option>
            <option *ngFor="let bagNb of bagsArr" [value]="bagNb">{{ bagNb }} {{ bagNb === 1 ?
              appCopy.panelHeader['bagSelectText'+selectedLanguage] :
              appCopy.panelHeader['bagsSelectText'+selectedLanguage] }}</option>
          </select>
          <label class="control-label" for="BagCount">{{ appCopy.panelHeader['bagLable'+selectedLanguage] }}</label>
        </div> -->

          <div class='booking-summary__bagsDropdown'>
            <!-- header -->
            <div class="flex-always flex--space-between flex--align-end dropdownHeader" (click)="toggleBagsDropdown()">
              <div class='flex-always flex__item--grow '>
                <i class="icon">luggage</i>
                <p class='dropdown-title margin-left-24'>{{ appCopy.panelHeaderInBound['bagLable'+selectedLanguage] }}
                </p>
              </div>
              <i class="icon">{{toggleDropdown ? 'chevron_up' : 'chevron_down'}}</i>
            </div>
            <!-- body -->
            <div *ngIf="toggleDropdown" [@Dropdown] class="dropdownBody padding-left-24">
              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['bagInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span class="text-extra-bold">{{ appCopy.panelHeaderOutBound[bagItems.bags > 1 ? 'bagsSelectText' :
                    'bagSelectText' +
                    selectedLanguage] }}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.bags-1, 'bags', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.bags === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.bags}}</strong>
                  <button (click)="updateBagItems(bagItems.bags+1, 'bags', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['childItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['childItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.childEquipment-1, 'childEquipment', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.childEquipment === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.childEquipment}}</strong>
                  <button (click)="updateBagItems(bagItems.childEquipment+1, 'childEquipment', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>

              <div class="dropdown-item">
                <div class='flex-always'>
                  <div class="bagtooltip margin-right-8">
                    <span class="icon-span icon-span-small tooltip-trigger-text">
                      <span class="icon-information icon-black icon_12">
                      </span>
                    </span>
                    <span
                      class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeaderOutBound['supportItemInfoText'+selectedLanguage]}}</span>
                  </div>
                  <span
                    class="text-extra-bold">{{appCopy.panelHeaderOutBound['supportItemLable'+selectedLanguage]}}</span>
                </div>
                <div class='bag--buttons flex-always'>
                  <button (click)="updateBagItems(bagItems.oversizeItem-1, 'oversizeItem', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-right-8' [disabled]="bagItems.oversizeItem === 0">
                    <span class="icon-minus icon-black icon_16">
                    </span>
                  </button>
                  <strong class="dropdown-item--value">{{bagItems.oversizeItem}}</strong>
                  <button (click)="updateBagItems(bagItems.oversizeItem+1, 'oversizeItem', 'ccd')"
                    class='iconBtn icon-span icon-span-small margin-left-8' [disabled]="virtualBags > 25">
                    <span class="icon-plus-outline icon-black icon_16">
                      <span class='path1'></span>
                      <span class='path2'></span>
                    </span>
                  </button>
                </div>
              </div>
              <p class="info-block">{{appCopy.panelHeaderOutBound['minPricePerBag'+selectedLanguage].replace('%s', inboundAdditionBagPrice)}}</p>
              <p *ngIf="virtualBags === 0" class="help-block text-danger">{{appCopy.panelHeaderOutBound['leastItemMessage'+selectedLanguage]}}</p>
              <p *ngIf="virtualBags > 25" class="help-block text-danger">{{appCopy.panelHeaderOutBound['maxBagItemError'+selectedLanguage]}}</p>            </div>
          </div>
        </div>

        <div class="booking-steps">
          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 1,
            'step--inactive': currentPanel < 1,
            'step--complete': currentPanel > 1
          }">
            <div class="flex flex-always flex--align-start">
              <img style="margin-right: 28px;" class="airline-logo-full-small" [src]="'./images/airline-logo-small/' + airlineName + '.svg'" [alt]="airlineName + ' logo'" />

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                    appCopy.panelHeaderInBound['bagInjectText'+selectedLanguage]}}</p>
                <div class="step__details">
                  <p>
                    <strong class="is-active">{{ appCopy.panelHeaderInBound['activeFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['inactiveFlightText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ flightData.flightResponse.flightStatusDetails[0].airlineName }}
                      {{flightData.flightResponse.flightInfo.requestFlightNumber }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ appCopy.panelHeaderInBound['to'+selectedLanguage] }}
                    {{
                    appAirportCopy[flightData.flightResponse.flightStatusDetails[flightData.flightResponse.flightStatusDetails.length
                    - 1].arrivalAirport.airportCode]['airportName'+selectedLanguage]}}
                  </p>
                </div>
              </div>
              <a class="btn btn-link" href="javascript:void(0)" (click)="goToFlightResults()"><i
                  class="icon">edit</i></a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 2,
            'step--inactive': currentPanel < 2,
            'step--complete': currentPanel > 2
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 2}" >
              <i class="icon-location step__icon"></i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{ appCopy.panelHeaderInBound['addressText'+selectedLanguage]
                  }}</p>

                <!-- INBOUND - delivery-->
                <div class="step__details" *ngIf="flightDirection === 2">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderInBound['addressActiveText'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['addressInactiveText'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ currentBooking.bookingJourney[0].deliveryLocation.name ?
                      currentBooking.bookingJourney[0].deliveryLocation.name :
                      currentBooking.bookingJourney[0].deliveryLocation.addressLine1 + ' ' +
                      currentBooking.bookingJourney[0].deliveryLocation.addressLine2 }}
                    </strong>
                  </p>
                  <!-- <p class="is-complete" *ngIf="isAirportToAirport && currentBooking.bookingJourney[0].deliveryLocation.name">
                  {{ currentBooking.bookingJourney[0].deliveryLocation.addressLine1 }}
                </p> -->
                  <p class="is-complete">
                    {{ currentBooking.bookingJourney[0].deliveryLocation.addressPostCode }}, {{
                    currentBooking.bookingJourney[0].deliveryLocation.addressTown }}
                  </p>
                </div>
              </div>
              <a *ngIf="flightDirection === 2 && bookingSectionComplete.deliveryLocationDetail"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('delivery-location')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

          <div class="panel-body step" [ngClass]="{
            'step--active': currentPanel === 3,
            'step--inactive': currentPanel < 3,
            'step--complete': currentPanel > 3
          }">
            <div class="flex flex-always" [ngClass]="{'flex--align-start':  currentPanel > 3}" >

              <i class="icon-time step__icon ">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>

              <div class="flex__item--grow">
                <p class="step__title text-caption fadeIn">{{
                  appCopy.panelHeaderInBound['bagJobDateLabel'+selectedLanguage] }}
                </p>

                <!-- INBOUND - timeslot-->
                <div class="step__details">
                  <p>
                    <!-- <strong class="is-active">{{ appCopy.panelHeaderInBound['timesloteActive'+selectedLanguage]
                      }}</strong> -->
                    <strong class="is-inactive">{{ appCopy.panelHeaderInBound['bagJobDateLabel'+selectedLanguage]
                      }}</strong>
                    <strong class="is-complete">
                      {{ timeslot.date | date:'E, d MMM yyyy' :'' : languageCode }}
                    </strong>
                  </p>
                  <p class="is-complete">
                    {{ timeslot.start }} - {{ timeslot.end }}
                  </p>
                </div>
              </div>
              <a *ngIf="flightDirection === 2 && bookingSectionComplete.deliveryDateTimeDetails"
                class="btn btn-link" href="javascript:void(0)" (click)="goToPanel('delivery-time')">
                <i class="icon">edit</i>
              </a>
            </div>
          </div>

        </div>

      </div>

      <div class="panel-body booking-type no-before" [ngClass]="{
      'step--highlight': priceLoaded && showPrice
    }">
        <div class="booking-type-heading ">
          <span class="icon-wrapper">
            <i class="icon-payment"></i>
          </span>

          <label class="booking-type-label text-bold" for="BagCount">
            <p class="step__title text-bold fadeIn">{{ appCopy.panelHeader['paymentReviewText'+selectedLanguage] }}
            </p>
            <!-- <div class="step__details">
              <p>
                <strong class="is-active">{{ appCopy.panelHeader['paymentActiveText'+selectedLanguage] }}</strong>
                <strong class="is-inactive">{{ appCopy.panelHeader['paymentReviewText'+selectedLanguage] }}</strong>
                <strong class="is-complete"></strong>
              </p>
            </div> -->
          </label>
        </div>
      </div>


      <div class="reveal reveal__price-view reveal--small" *ngIf="priceLoaded && showPrice && price.totalPrice">

        <div class="reveal__always_show panel-body">
          <div class="desktopViewSidePanel" *ngIf="screenSize > 1024">
            <app-promo [price]="price" [user]="user" [togglePromo]="togglePromo" [appCopy]="appCopy"
              [selectedLanguage]='selectedLanguage'>
            </app-promo>
            <!--- Begin Mention Me referee placeholder div -->
            <!-- <div id="mmWrapper" class="margin-top-12 mmWrapper--link" (click)="togglePromo = true"></div> -->
            <!--- End Mention Me referee placeholder div -->
          </div>
          <div class="margin-top-16">
            <div class="flex-always flex--space-between">
              <div>
                <p>{{ appCopy.panelHeader['total'+selectedLanguage] }}</p>
              </div>
              <p class="total-price">
                {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF"
                ? ' ' :
                ''}}{{ price.totalPrice.majorAmount}}</p>
            </div>
          </div>
          <a class="price-breakdown-button" (click)="openPriceBreakDown()">{{ appCopy.panelHeader['priceBreakdownTitle'+selectedLanguage] }}</a>
        </div>

      </div>

      <!-- <button class="btn hidden-sm hidden-xs chat-btn" (click)="handleChatClick()">
      <div *ngIf="!chatIsLoading"> <i class="far fa-comment"></i>&nbsp;Chat</div>
      <div class="loader-container-btn" *ngIf="chatIsLoading">
        <div class="loader loader--gray">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
    </button> -->
    </div>
  </ng-template>
</div>
